import { MainReport } from '@api/order-reporting/types-deliveries/DeliveriesReports';
import { MainReportGridData, PrefixedDeliveryData, DeliveryPrefix } from '@pages/reporting-pages/deliveries-main/types/MainReportGridData';
import { MainTransportTypes } from '@api/order-reporting/types-deliveries/CountryDeliveriesSummaryReport';
import { valueExist } from '@utils/typescriptGuards';
import { CountryDeliveriesDistributionPartWithReturns } from '@api/order-reporting/types-deliveries/CountryDeliveriesDistributionPart';



export const convertToGridData = (apiData: MainReport[] | undefined | null): MainReportGridData[] | null => {
	if (!apiData) return null;

	let gridData: MainReportGridData[] = [];
	if (apiData.length === 0)
		return gridData;
	
	for (const apiDataItem of apiData) {
		const sdValue = apiDataItem.transportTypesData[MainTransportTypes.sd];
		const intValue = apiDataItem.transportTypesData[MainTransportTypes.int];
		const ddValue = apiDataItem.transportTypesData[MainTransportTypes.dd];
		const tdValue = apiDataItem.transportTypesData[MainTransportTypes.td];

		gridData.push({
			country: apiDataItem.country,
			executionPlaceName: apiDataItem.executionPlaceName,
			...createFields('sd', sdValue),
			...createFields('int', intValue),
			...createFields('dd', ddValue),
			...createFields('td', tdValue),
		});
	}

	return gridData;
}



const createFields = <T extends DeliveryPrefix>(prefix: T, data: CountryDeliveriesDistributionPartWithReturns | null | undefined): PrefixedDeliveryData<T> => {
	return {
		[`${prefix}_volume`]: data && valueExist(data.volume) ? data.volume : 0,
		[`${prefix}_volumePct`]: data && valueExist(data.volumePct) ? data.volumePct : 0,
		[`${prefix}_weight`]: data && valueExist(data.weight) ? data.weight : 0,
		[`${prefix}_ordersCount`]: data && valueExist(data.ordersCount) ? data.ordersCount : 0,
		[`${prefix}_returnsWeight`]: data && valueExist(data.returnsWeight) ? data.returnsWeight : 0,
	} as PrefixedDeliveryData<T>;
};